"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultFormat_1 = __importStar(require("../../defaults/getDefaultFormat"));
var date_fns_1 = require("date-fns");
/**
 * formatDate
 */
var formatDate = function (date, dateForm) {
    var dateFormat = dateForm ? getDefaultFormat_1.default(dateForm) : getDefaultFormat_1.default(getDefaultFormat_1.Format.date);
    return date ? date_fns_1.format(new Date(date * 1000), dateFormat) : '';
};
exports.default = formatDate;
